import ContactInformation from './contactinformation'

export default ContactInformation
